// extracted by mini-css-extract-plugin
module.exports = {"openings":"JobList_openings__NIlTl","title":"JobList_title__y_Rtg"};